import { FeatureFlags } from '../../feature-flags/feature-flags-service';
import { FAKE_DB_COLLECTIONS_TOKEN } from './fake-db-collections-token';

const db = {
  // note: angular-in-memory-web-api is forcing us to use all lower case for this collection name
  featureflags: FeatureFlags.allEnabledFlags
};
export const FeatureDbProvider = { provide: FAKE_DB_COLLECTIONS_TOKEN, multi: true, useValue: db };
